import { z } from "zod";

import { TIME_PERIOD_PRESETS } from "../../../../shared/domain/dashboard/time-period.constants";

/**
 * GET /api/dashboard/export
 *
 * Export dashboard data as CSV file.
 */

export const EXPORT_FORMATS = ["consolidated", "statistics", "messages"] as const;

export const ExportDashboardDataQuerySchema = z.object({
  timePeriod: z.enum(TIME_PERIOD_PRESETS).optional(),
  startDate: z.string().optional(), // ISO date string
  endDate: z.string().optional(), // ISO date string
  deploymentId: z.string().uuid().optional(),
  exportFormat: z.enum(EXPORT_FORMATS).optional() // defaults to "consolidated"
});

export type ExportFormat = (typeof EXPORT_FORMATS)[number];

// Binary response (CSV file) - no response schema needed
